<ion-button *ngIf="show" (click)="onClick()">
    <ion-icon [name]="iconName"></ion-icon>
</ion-button>
